import i18n from '@/plugins/vue-i18n';
export default {
  data() {
    return {
      marketId: this.$route.params.marketId,
    }
  },
  methods: {
    validateThaiCitizenID(id) {
      if (id.length != 13 || id.charAt(0).match(/[09]/)) return false;
      let sum = 0;
      for (let i = 0; i < 12; i++) {
        sum += parseInt(id.charAt(i)) * (13 - i);
      }
      if ((11 - sum % 11) % 10 != parseInt(id.charAt(12))) {
        return false;
      }
      return true;
    },
    validateThaiCitizenIDStatus(citizenId, isVat, enableRDWebService) {
      let res = { text: '', numberIsCorrect: false, formatIsCorrect: false, isHidden: false, tooltipText: '' }
      let tagStart = '<div style="text-align:center;">'
      let tagEnd = '</div>'
      let tagTail = enableRDWebService ? `<br>${i18n.t('validate.if_you_want_to_check_directly_with_rd_web_service')} <b>${i18n.t('rd_web_service')}</b> ${i18n.t('click')}!` : ''
      if (!citizenId || citizenId.length == 0) {
        res.isHidden = true
      } else if (citizenId && citizenId.match(/[^0-9]/)) {
        res.text = `${i18n.t('validate.please_input_data_format')} <b>${i18n.t('number')}</b> ${i18n.t('only')}`
        res.tooltipText = `${tagStart}${i18n.t('account.citizen_id_label')}${i18n.t('tax.tax_id_number_another_form')}<br>${i18n.t('validate.must_input_data_format')} <b>${i18n.t('number')}</b> ${i18n.t('only')}${tagEnd}`
      } else if (citizenId && citizenId.length != 13) {
        res.text = `${i18n.t('validate.please_input_data_complete')} <b>13</b> ${i18n.t('main')}`
        res.tooltipText = `${tagStart}${i18n.t('validate.please_input_data_complete')} <b>13</b> ${i18n.t('main')}<br>( ${i18n.t('now_have')} ${citizenId.length} ${i18n.t('main')})<br>${citizenId.length > 13 ? ` <b>${i18n.t('number_of_digit')}</b> ${i18n.t('defined')}` : `${i18n.t('number_of_digit')} <b>${i18n.t('less_than')}</b> ${i18n.t('defined')}`}${tagEnd}`
      } else if (citizenId && citizenId.length == 13) {
        res.formatIsCorrect = !isVat ? this.validateThaiCitizenID(citizenId) : false
        res.numberIsCorrect = true
        if (!isVat && res.formatIsCorrect) {
          res.text = `${i18n.t('format')} <b>${i18n.t('correct')}</b>`
          res.tooltipText = `${tagStart}${i18n.t('from_check')} <b>${i18n.t('basic')}</b> ${i18n.t('format_of')}<br>${i18n.t('account.citizen_id_label')}<br>${i18n.t('has_format')} <b>${i18n.t('correct')}</b>${tagTail}${tagEnd}`
        } else if (!isVat && !res.formatIsCorrect) {
          res.text = `${i18n.t('format')} <b>${i18n.t('incorrect')}</b>`
          res.tooltipText = `${tagStart}${i18n.t('from_check')} <b>${i18n.t('basic')}</b> ${i18n.t('format_of')}<br>${i18n.t('account.citizen_id_label')}<br>${i18n.t('has_format')} <b>**${i18n.t('incorrect')}</b><br><br>**${i18n.t('validate.check_basic_format_of_citizen_id')}${tagTail}${tagEnd}`
        } else if (isVat) {
          res.text = `${i18n.t('format')} <b>${i18n.t('correct')}</b>`
          res.tooltipText = `${tagStart}${i18n.t('from_check')} <b>${i18n.t('basic')}</b> ${i18n.t('validate.number_of_digit_is_correct')}${tagTail}${tagEnd}`
        } else {
          res.text = '-'
          res.tooltipText = `${tagStart}-${tagEnd}`
        }
      } else { }
      return res
    },
  }
}